import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import utils from '@utils';

class LocationFormatter extends Component {
	shouldComponentUpdate = ({ row }) => {
		const {
			LocationName, LocationAddress, LocationCity, LocationState, LocationZipcode, LocationLatitude, LocationLongitude,
		} = row;
		const lastProps = this.props;

		return (
			!isEqual(LocationName, lastProps.row.LocationName)
			|| !isEqual(LocationAddress, lastProps.row.LocationAddress)
			|| !isEqual(LocationCity, lastProps.row.LocationCity)
			|| !isEqual(LocationState, lastProps.row.LocationState)
			|| !isEqual(LocationLatitude, lastProps.row.LocationLatitude)
			|| !isEqual(LocationLongitude, lastProps.row.LocationLongitude)
			|| !isEqual(LocationZipcode, lastProps.row.LocationZipcode)
		);
	}

	render() {
		const { row } = this.props;
		const addressParams = {
			address   : row.LocationAddress,
			city      : row.LocationCity,
			state     : row.LocationState,
			zip       : row.LocationZipcode,
			latitude  : row.LocationLatitude,
			longitude : row.LocationLongitude,
		};
		const formattedAddress = utils.concatenateAddressDetails({ ...addressParams }, { useMultiline : true });

		return (
			<div className="location-formatter">
				<h5>{ row.LocationName }</h5>
				<div className="location">
					<i className="rkf rkf-map-pin" />
					<div>
						<span>{ formattedAddress.top }</span>
						<span>{ formattedAddress.bottom }</span>
					</div>
				</div>
			</div>
		);
	}
}

LocationFormatter.propTypes = {
	row : PropTypes.object.isRequired,
};

export default LocationFormatter;
